import React from 'react';
import { FaTag, FaChevronRight } from 'react-icons/fa';
import './Toolbox.css';

const TOOLS = [
  {
    id: 'asset-tagger',
    label: 'Asset Tagger',
    description: 'Tag assets one-by-one on a floor plan, generate RFID codes, and pin locations on the map.',
    icon: FaTag,
    color: '#3b82f6',
  },
];

const Toolbox = ({ onNavigate }) => {
  return (
    <div className="toolbox-page">
      <div className="toolbox-header">
        <h1 className="toolbox-title">Toolbox</h1>
        <p className="toolbox-subtitle">Specialist tools for on-site work</p>
      </div>

      <div className="toolbox-grid">
        {TOOLS.map(tool => (
          <button
            key={tool.id}
            className="toolbox-card"
            onClick={() => onNavigate && onNavigate(tool.id)}
          >
            <div className="toolbox-card-icon" style={{ background: tool.color + '18', color: tool.color }}>
              <tool.icon />
            </div>
            <div className="toolbox-card-body">
              <div className="toolbox-card-label">{tool.label}</div>
              <div className="toolbox-card-desc">{tool.description}</div>
            </div>
            <FaChevronRight className="toolbox-card-arrow" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default Toolbox;
